<template>
    <div>
        <h2 class="title typographies-heading-h2">
            {{ $l10n.__('Paramètres des champs personnalisés') }}
        </h2>
        <p class="subtitle typographies-paragraph-medium-regular">
            {{
                $l10n.__(
                    'Cette section vous permet de déterminer les actions que nous devons effectuer uniquement sur les champs personnalisés.',
                )
            }}
        </p>
        <div class="cf-container">
            <div
                v-for="(customField, customFieldKey) in customFields"
                :key="customFieldKey"
                class="cf-item"
            >
                <div class="cf-title">
                    <span class="typographies-paragraph-medium-bold">
                        {{ customField.title }}
                    </span>
                    <CompassTooltip contentClass="tooltip-import-options" placement="bottom-start">
                        <template #content>
                            <div v-for="choice in customField.values" :key="choice.value">
                                <h4 class="typographies-heading-h4">{{ choice.label }}</h4>
                                <p class="typographies-paragraph-small-bold">
                                    {{ choice.description }}
                                </p>
                            </div>
                        </template>
                        <CompassIcon icon="info-circle-fill" size="small" />
                    </CompassTooltip>
                </div>
                <CompassSelect
                    v-model="getOptionsSelectedImport[customFieldKey]"
                    menuClass="menu-import-dialog"
                >
                    <CompassDropdownOption
                        v-for="option in customField.values"
                        v-bind="option"
                        :key="option.value"
                    />
                </CompassSelect>
            </div>
        </div>
        <span class="typographies-paragraph-small-regular caption-last-cf-select">
            {{
                $l10n.__(
                    'Champs personnalisés de type bouton radio, choix multiple, liste de choix',
                )
            }}
        </span>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const importsStore = createNamespacedHelpers('importsStore');
export default {
    data() {
        return {
            customFields: null,
        };
    },
    computed: {
        ...importsStore.mapGetters([
            'getOptionsImport',
            'getOptionsSelectedImport',
            'getCurrentSubStep',
            'getHasCustomFields',
        ]),
    },
    created() {
        this.customFields = this.getOptionsImport.customFields;
    },
    beforeMount() {
        //We set isValid at creation of component because for know it cannot be false
        this.getCurrentSubStep.isValid = this.getHasCustomFields;
    },
};
</script>

<style lang="scss" scoped>
.cf-item {
    :deep(.compass-icon) {
        color: var(--colors-common-icon-neutral);
    }
}
.caption-last-cf-select {
    color: var(--colors-common-text-subtle-default);
    margin-top: var(--spacing-0);
}
</style>
